export const termsOfUse = [
  {
    title: '1. Using this website',
    text: 'By visiting this website, you agree to use it lawfully and in a way that does not interfere with other visitors or the operation and security of the site. These terms apply to the informational La Vie Saigon website.',
  },
  {
    title: '2. Café information',
    text: 'Website descriptions, photographs, hours, and other details are provided for general information and may change. Menu items, ingredients, availability, and prices can vary by location and date. Please confirm current details with the café before relying on them.',
  },
  {
    title: '3. No online transactions',
    text: 'This website currently provides information about La Vie Saigon. It does not accept online food orders, reservations, payments, or customer account registrations.',
  },
  {
    title: '4. Intellectual property',
    text: 'The website’s text, branding, photographs, graphics, and other content belong to La Vie Saigon or their respective owners. You may view the site for personal, non-commercial use. Do not reproduce or use content commercially without permission.',
  },
  {
    title: '5. Third-party websites',
    text: 'Links to map, social media, or other third-party services are provided for convenience. Those services are operated independently and have their own terms and privacy practices. La Vie Saigon is not responsible for their content or operation.',
  },
  {
    title: '6. Availability and disclaimers',
    text: 'We make reasonable efforts to keep website information current, but the site and its content are provided as available. To the extent permitted by law, La Vie Saigon disclaims warranties not expressly stated here.',
  },
  {
    title: '7. Limitation of liability',
    text: 'To the extent permitted by applicable law, La Vie Saigon is not liable for indirect or consequential loss arising from use of, or inability to use, this informational website. Nothing in these terms limits liability that cannot legally be limited.',
  },
  {
    title: '8. Updates and applicable law',
    text: 'We may update these terms by publishing a revised version on this page. Continued use after an update means you accept the revised terms. These terms are governed by the laws of the Commonwealth of Virginia, without displacing any consumer rights that apply by law.',
  },
];

export const privacyPolicy = [
  {
    title: '1. Information this site handles',
    text: 'This public website does not currently offer customer checkout, online ordering, account registration, or a contact form. When you browse a website, the hosting and security services needed to deliver it may process basic technical information such as your IP address, browser, and requested pages.',
  },
  {
    title: '2. How information is used',
    text: 'Technical information may be used to deliver the site, maintain its security, diagnose errors, and keep the service working. If you contact the café using a third-party service or a channel outside this website, that information is handled through that channel.',
  },
  {
    title: '3. Cookies and local storage',
    text: 'Your browser or service providers may use essential technologies to operate or secure online services. You can manage cookies and local storage through your browser settings; disabling them may affect site or administrative features.',
  },
  {
    title: '4. Sharing and service providers',
    text: 'We do not sell personal information collected through this informational page. Technical data may be processed by providers that host, deliver, or secure the site, or disclosed when required by law or necessary to protect rights and safety.',
  },
  {
    title: '5. Retention and security',
    text: 'Technical information is retained only as needed for operational, security, and legal purposes. We use reasonable measures to protect information, but no internet transmission or storage system can be guaranteed to be completely secure.',
  },
  {
    title: '6. Your choices and requests',
    text: 'You can limit browser storage through your browser settings. To ask about personal information associated with an interaction with La Vie Saigon, contact the café through its published business channels. Applicable privacy laws may provide additional rights.',
  },
  {
    title: '7. Children and external links',
    text: 'This website is intended for a general audience and is not designed to collect information from children. External links lead to services with independent privacy policies; review those policies before sharing information with them.',
  },
  {
    title: '8. Policy updates',
    text: 'We may revise this policy as the website or its practices change. The current version will be published here. The site does not currently process customer orders or payments online.',
  },
];